
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/journalist",
      function () {
        return require("private-next-pages/register/journalist.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/journalist"])
      });
    }
  